import moment from 'moment';


function validateTimestamp(timestamp, dayName) {
    const timestampErrors = {};

    const In = timestamp[dayName + "In"] ? moment(timestamp[dayName + "In"], "HH:mm", true) : null;
    const Out = timestamp[dayName + "Out"] ? moment(timestamp[dayName + "Out"], "HH:mm", true) : null;
    const LunchIn = timestamp[dayName + "LunchIn"] ? moment(timestamp[dayName + "LunchIn"], "HH:mm", true) : null;
    const LunchOut = timestamp[dayName + "LunchOut"] ? moment(timestamp[dayName + "LunchOut"], "HH:mm", true) : null;

    // if Out comes before In
    if (In && Out && Out.diff(In, "hours", true) <= 0) {
        timestampErrors[dayName + "Out"] = "Must fall after shift begins.";
    }

    // if LunchOut comes before LunchIn
    if (LunchIn && LunchOut && LunchOut.diff(LunchIn, "hours", true) <= 0) {
        timestampErrors[dayName + "LunchOut"] = "Must fall after lunch begins.";
    }

    // if you clock in for lunch before your shift starts
    if (In && LunchIn && In.diff(LunchIn, "hours", true) >= 0) {
        timestampErrors[dayName + "LunchIn"] = "Must fall after the shift begins.";
    }

    // if you clock out for the day before lunch ends
    if (Out && LunchOut && Out.diff(LunchOut, "hours", true) <= 0) {
        timestampErrors[dayName + "LunchOut"] = "Must fall before the shift ends.";
    }

    // restrict paid hours to 8 per day
    if (In && Out) {
        let paidHours = Out.diff(In, "minutes") / 60;

        if (LunchIn && LunchOut) {
            paidHours -= LunchOut.diff(LunchIn, "minutes") / 60;
        }

        if (paidHours > 8) {
            timestampErrors[dayName + "Out"] = "Students cannot enter more than 8 paid hours in one day.";
        }
    }
    
    return timestampErrors;
}

function getTimestampByDay(timesheet, dayName) {
    return {
        [dayName + "In"]: timesheet[dayName + "In"],
        [dayName + "Out"]: timesheet[dayName + "Out"],
        [dayName + "LunchIn"]: timesheet[dayName + "LunchIn"],
        [dayName + "LunchOut"]: timesheet[dayName + "LunchOut"],
    }
}

export const validateStudentTimesheet = function(timesheet) {
    const errors = {};
    const daysOfTheWeek = ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

    daysOfTheWeek.map((dayName) => {
        const timestamp = getTimestampByDay(timesheet, dayName);
        const timestampErrors = validateTimestamp(timestamp, dayName);
        Object.assign(errors, timestampErrors);
    });

    return errors;
}

export default validateStudentTimesheet;
// import moment from 'moment';


// function validateTimestamp(timestamp, dayName) {
//     const timestampErrors = {};

//     const In = moment(timestamp[dayName + "In"], "hh:mm");
//     const Out = moment(timestamp[dayName + "Out"], "hh:mm");
//     const LunchIn = moment(timestamp[dayName + "LunchIn"], "hh:mm");
//     const LunchOut = moment(timestamp[dayName + "LunchOut"], "hh:mm");

//     //if Out comes before In
//     if (Out.diff(In, "hours", true) <= 0) timestampErrors[dayName + "Out"] = "Must fall after shift begins."

//     //if LunchOut comes before LunchIn
//     if (LunchOut.diff(LunchIn, "hours", true) <= 0) timestampErrors[dayName + "LunchOut"] = "Must fall after lunch begins."

//     //If you clock in for lunch before your shift starts   
//     if (In.diff(LunchIn, "hours", true) >= 0) timestampErrors[dayName + "LunchIn"] = "Must fall after the shift begins."

//     if (Out.diff(LunchOut, "hours", true) <= 0) timestampErrors[dayName + "LunchOut"] = "Must fall before the shift ends."
    
//     return timestampErrors;
// }

// function getTimestampByDay(timesheet, dayName) {
//     return {
//         [dayName + "In"]: timesheet[dayName + "In"],
//         [dayName + "Out"]: timesheet[dayName + "Out"],
//         [dayName + "LunchIn"]: timesheet[dayName + "LunchIn"],
//         [dayName + "LunchOut"]: timesheet[dayName + "LunchOut"],
//     }
// }

// export const validateStudentTimesheet = function(timesheet) {
//     const errors = {};
//     /*const daysOfTheWeek = ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]

//     daysOfTheWeek.map((dayName) => {
//         // Get timestamp errors by day name {"SaturdayIn" : x, "SaturdayOut" : y ...}  
//         const timestamp = getTimestampByDay(timesheet, dayName);

//         // Check timestamps for errors 
//         const timestampErrors = validateTimestamp(timestamp, dayName);

//         // Add timestamp-specific errors to error object   
//         Object.assign(errors, timestampErrors);
//     });*/

//     return errors;
// }

// export default validateStudentTimesheet;